import React from 'react';
import { func } from 'prop-types';
import classNames from 'classnames/bind';
import qs from 'qs';

import { withSearchContext } from 'containers/withSearchContext';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import browserHistory from 'utils/browserHistory';
import { clearSearchHistory } from 'utils/historyPushSearch';

import CarIcon from 'media/icons/choix-voiture.icon.svg';
import TruckIcon from 'media/icons/choix-camion.icon.svg';

import styles from './SwitcherVehicleType.module.scss';

const cx = classNames.bind(styles);

const SwitcherVehicleType = ({
  resetSearchResults,
  contextSearch: { vehicleType, setVehicleType },
}) => {
  const onCarTypeChange = (e) => {
    setVehicleType(e.target.value);
    resetSearchResults();
    clearSearchHistory(browserHistory.location.search);

    let queryValues = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    browserHistory.push({
      search:
        '?' + qs.stringify({ ...queryValues, vehicleType: e.target.value }),
    });
  };

  return (
    <div className={cx('root')}>
      <button
        className={cx('button', { active: vehicleType === 'P' })}
        value="P"
        type="button"
        onClick={onCarTypeChange}
      >
        <CarIcon className={cx('icon', 'icon-car')} />
      </button>
      <button
        className={cx('button', { active: vehicleType === 'O' })}
        value="O"
        type="button"
        onClick={onCarTypeChange}
      >
        <TruckIcon className={cx('icon', 'icon-truck')} />
      </button>
    </div>
  );
};

SwitcherVehicleType.propTypes = {
  resetSearchResults: func.isRequired,
};

export default withSearchContext(withErrorBoundary(SwitcherVehicleType));



// WEBPACK FOOTER //
// ./src/components/SwitcherVehicleType/SwitcherVehicleType.js